import "./Highlights.css";

/** items: [{ key, kicker, loading, highlight }] where highlight comes from highlightRules.js. */
export default function Highlights({ items, onAction }) {
  const shown = items.filter((item) => item.loading || item.highlight);
  if (!shown.length) return null;
  return <section className="sa-highlights" aria-label="Highlights">
    {shown.map((item) => {
      if (item.loading) {
        return <article key={item.key} className="sa-highlight is-loading" aria-busy="true">
          <span className="sa-highlight-kicker">{item.kicker}</span>
          <p>Checking…</p>
        </article>;
      }
      const { kicker, tone, text, action } = item.highlight;
      return <article key={item.key} className={`sa-highlight sa-highlight--${tone}`}>
        <span className="sa-highlight-kicker">{kicker}</span>
        <p>{text}</p>
        {action && <button type="button" className="sa-highlight-action" onClick={() => onAction(action)}>
          {action.label} <span aria-hidden="true">→</span>
        </button>}
      </article>;
    })}
  </section>;
}
